
import NfdrSelect from './NfdrSelect';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WeatherDateSlider from '../weatherContents/WeatherDateSlider';

const NfdrTools = () => {
    return (
        <>
            <Accordion className='accordion-style' defaultExpanded>
                <AccordionSummary
                    className='accordion-title'
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="Date Slider"
                    id="Date"
                >
                    <label id='TimePicker' htmlFor='TimePicker'>Date</label>
                    
                </AccordionSummary>
                <AccordionDetails>
                    <div style={{ width: '94%' }}>
                        <WeatherDateSlider/>
                    </div>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordion-style' defaultExpanded>
                <AccordionSummary
                    className='accordion-title'
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="Nfdr"
                    id="Nfdr"
                >
                    <label id='nfdrData' htmlFor='nfdrData'>NFDRS Data</label>
                </AccordionSummary>
                <AccordionDetails>
                  <NfdrSelect/>
                </AccordionDetails>
            </Accordion>

        </>
    )
}

export default NfdrTools;
